import CRMTripManagement from "../Trips";

export default function CRMDisneyCruise() {
  return <CRMTripManagement destination="disney_cruise" />;
}
